
import Axios from 'axios'
import store from '../store'
export default {

    async submitPreflightBetInfo() {
        Axios.defaults.headers.common['Authorization'] = 'Bearer ' + store.getters.accessToken;
        try {
            const resp = await Axios.get(`/api/liveinplay/retrieve/preflight/token?punterId=${store.getters.punterId}`);
            return resp.data;
        } catch (err) {
            console.log(err);
            return null;
        }
    },

    submitBet(betCriteria) {
        var criteria = {
            punterId: betCriteria.punterId ? betCriteria.punterId : store.getters.punterId,
            totalOdds: betCriteria.totalOdds,
            totalStake: betCriteria.totalStake,
            totalPayout: betCriteria.totalPayout,
            priceChangeDrift: betCriteria.priceChangeDrift,
            betLegs: [],
            requestId: store.getters.submitBetRequestId
        }

        let betlegsLength = betCriteria.betLegs.length;
        for (let i = 0; i < betlegsLength; i++) {
            criteria.betLegs.push(betCriteria.betLegs[i].betleg);
        }
        Axios.defaults.headers.common['Authorization'] = 'Bearer ' + store.getters.accessToken;
        return Axios.post(`/api/liveinplay/submit`, criteria)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            })
    }
}